import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.tsx';
import Login from './pages/Login.tsx';
import Dashboard from './pages/Dashboard.tsx';
import Users from './pages/Users.tsx';
import Surveys from './pages/Surveys.tsx';
import Assignments from './pages/Assignments.tsx';
import SurveyStatus from './pages/SurveyStatus.tsx';
import Analytics from './pages/Analytics.tsx';
import Files from './pages/Files.tsx';
import AdminManagement from './pages/AdminManagement.tsx';
import AdminSettings from './pages/AdminSettings.tsx';
import Settings from './pages/Settings.tsx';
import { AuthProvider, useAuth } from './contexts/AuthContext.tsx';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return <>{children}</>;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return (
      <div className="main-container">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    );
  }
  
  return (
    <div className="main-container">
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/surveys" element={<Surveys />} />
          <Route path="/assignments" element={<Assignments />} />
		  <Route path="/survey-status" element={<SurveyStatus />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/files" element={<Files />} />
          <Route path="/admin-management" element={<AdminManagement />} />
          <Route path="/settings" element={<AdminSettings />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Layout>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
